// How the homepage names and draws the template's gear. Names are shortened
// to what fits under a small drawing; art keys are Illustration names.
const GEAR = {
  'ARRI Alexa Mini LF': ['Alexa Mini LF', 'gearCamera'],
  'SmallHD Cine 7': ['SmallHD Cine 7', 'gearMonitor'],
  'Teradek Bolt 4K LT 750': ['Teradek Bolt', 'gearTransmitter'],
  'V-Mount Battery 150Wh': ['V-Mount battery', 'gearBattery'],
  'Zeiss Supreme Prime 50mm T1.5': ['Zeiss 50mm', 'gearPrime'],
  'Canon CN-E 24mm T1.5 L F': ['Canon 24mm', 'gearPrimeShort'],
  'ARRI SkyPanel S60-C': ['SkyPanel S60', 'gearPanel'],
  'Aputure 600d Pro': ['Aputure 600d', 'gearCob'],
};

export const shortName = (name) => GEAR[name]?.[0] || name;
export const gearArt = (name) => GEAR[name]?.[1] || 'gearCamera';
